import { make } from 'vuex-pathify'
import actions from './actions'

const initialState = () => ({
  activeCampaigns: null
})

const state = initialState()

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
